




















import { registeredHandlers } from '@/decorators/unsaved-changes';
import { Component, Vue } from 'vue-property-decorator';

// This component will handle reloading the page when the update is available
// if for some reason page cannot be reloaded (unsaved changes) user will still
// see the update notification and be able to click update button
@Component
export default class SWAppUpdate extends Vue {
  private updateExists = false;
  private secondsUntilReload = 120;

  private refresh() {
    this.updateExists = true;
    setInterval(() => this.secondsUntilReload += -1, 1000);
    setTimeout(() => {
      this.refreshApp();
    }, 1000 * this.secondsUntilReload);
  }

  refreshApp() {
    registeredHandlers.forEach(handler => window.removeEventListener('beforeunload', handler));
    window.location.reload();
  }
}
